export default "__VITE_ASSET__BbUKxCrK__"